module.exports = __webpack_public_path__ + "0b8c7274a9a9fa3c3c882486842e06c1.pdf";